function createShareUrl({ title, text, url }) {
  let encodedText = encodeURIComponent(text)

  if (title) {
    const encodedTitle = encodeURIComponent(title)
    encodedText = encodedTitle + ' - ' + encodedText
  }

  const encodedUrl = encodeURIComponent(url)
  return `https://api.whatsapp.com/send?text=${encodedText} ${encodedUrl}`
}

export default {
  id: 'whatsapp',
  title: 'Whatsapp',
  createShareUrl
}
